import LayoutTransition from '@/layouts/LayoutTransition.vue';
import MainLayout from '@/layouts/main/Main.vue';

import StartPage from '@/pages/StartPage.vue';
import IntroPage from '@/pages/IntroPage.vue';
import StoryPage from '@/pages/StoryPage.vue';
import FormPage from '@/pages/FormPage.vue';
import StoryFeedbackPage from '@/pages/StoryFeedbackPage.vue';
import StoryEndPage from '@/pages/StoryEndPage.vue';
import AdditionalUserInfoPage from '@/pages/AdditionalUserInfoPage.vue';
import VueRouter from 'vue-router';
import QuestionBlockPage from '@/pages/QuestionBlockPage';
import QuestionBlockChoosePage from '@/pages/QuestionBlockChoosePage';
import ChatPage from '@/pages/ChatPage.vue';
import SurveyEnd from '@/pages/SurveyEnd.vue';
import TooYoungForSurvey from '@/pages/TooYoungForSurvey.vue';
import TooOldForSurvey from '@/pages/TooOldForSurvey.vue';

let router = null;

export default function createRouter() {
  router = new VueRouter({
    mode: 'history',

    scrollBehavior(to, from, savedPosition) {
      const position = {
        x: 0,
        y: 0
      };
      return new Promise(resolve => {
        this.app.$root.$once('scrollBeforeEnter', () => {
          resolve(position);
        });
      });
    },
    routes: [
      {
        path: '',
        component: LayoutTransition,
        children: [
          {
            path: '/',
            name: 'start',
            component: StartPage
          },
          {
            path: '',
            component: MainLayout,
            children: [
              {
                path: '/intro',
                name: 'intro',
                component: IntroPage
              },
              {
                path: '/story/:id',
                name: 'story',
                component: StoryPage
              },
              {
                path: '/om-dig',
                name: 'form',
                component: FormPage
              },
              {
                path: '/kanner-igen-dig',
                name: 'feedback',
                component: StoryFeedbackPage
              },
              {
                path: '/tack',
                name: 'story-end',
                component: StoryEndPage
              },
              {
                path: '/mer-om-dig/:id',
                name: 'story-additional',
                component: AdditionalUserInfoPage
              },
              {
                path: '/questions/:id',
                name: 'question-block',
                component: QuestionBlockPage
              },
              {
                path: '/questions',
                name: 'question-blocks',
                component: QuestionBlockChoosePage
              },
              {
                path: '/chat/:id',
                name: 'chat',
                component: ChatPage
              },
              {
                path: '/end',
                name: 'survey-end',
                component: SurveyEnd
              },
              {
                path: '/under-10',
                name: 'under-10',
                component: TooYoungForSurvey
              },
              {
                path: '/over-18',
                name: 'over-18',
                component: TooOldForSurvey
              }
            ]
          }
        ]
      }
    ]
  });
  return router;
}
